import { SearchTerm } from "./SearchTerm";

const MusteringReportSearch: SearchTerm[] = [
    {
        heading: "Category",
        accessor: "profile",
        searchOnName: "profile.trnName",
        translationKey: "category"
    },
    {
        heading: "Company",
        accessor: "company",
        searchOnName: "company.compName",
        translationKey: "company"
    },
    {
        heading: "Department",
        accessor: "department",
        searchOnName: "department.deptName",
        translationKey: "department"
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "mstDisplayname",
        translationKey: "displayName"
    },
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "mstFirstname",
        translationKey: "firstName"
    },
    {
        heading: "ID Number",
        accessor: "idNumber",
        searchOnName: "mstIdnumber",
        translationKey: "idNumber"
    },
    {
        heading: "Last Name",
        accessor: "lastname",
        searchOnName: "mstLastname",
        translationKey: "lastName"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        searchOnName: "mstSuffix",
        translationKey: "suffix"
    },
];

export default MusteringReportSearch;